var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9581 35.1147C22.6642 35.6215 22.2422 36.0422 21.7345 36.3346C21.2268 36.627 20.6513 36.7809 20.0654 36.7809C19.4795 36.7809 18.9039 36.627 18.3962 36.3346C17.8885 36.0422 17.4666 35.6215 17.1726 35.1147M30.0981 13.3772C30.0981 10.7164 29.041 8.16456 27.1596 6.28307C25.2781 4.40158 22.7262 3.34457 20.0654 3.34457C17.4045 3.34457 14.8527 4.40158 12.9712 6.28307C11.0897 8.16456 10.0327 10.7164 10.0327 13.3772C10.0327 25.082 5.01636 28.4263 5.01636 28.4263H35.1144C35.1144 28.4263 30.0981 25.082 30.0981 13.3772Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b049ade8ea0205ae73292f643b5e7afb.svg";
export { ForwardRef as ReactComponent };